import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useInterestArea({cameraId, onError, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    queryKey: [QueryKeyEnum.INTEREST_AREA, cameraId],
    queryFn: async () => (await api.barriers.getBarriers({cameraId})).data.data,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
